import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { ModalProgressBar } from "components/HelperComponents/ModalProgressBar";
import showToast from "helpers/showToast";
import IconLoader from "components/IconLoader/IconLoader";

const DeleteDialog = ({
  show,
  onHide,
  deleteAction,
  modalTitle = "DIALOG.DELETERECORD",
  modalMessage = "DIALOG.DELETEMESSAGE",
  backdrop = true,
  textCheck,
  id,
  type,
  warningMessage,
  deleteButtonLabel = "DIALOG.CONFIRMDELETE"
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [validation, setValidation] = useState();

  function confirmDialog() {
    if (deleteAction && typeof deleteAction === "function") {
      setIsLoading(true);
      deleteAction();
      setIsLoading(false);
    } else {
      showToast("ERROR.UNKNOWN", { type: "error" });
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop={isLoading ? "static" : backdrop}
      keyboard={!isLoading}
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={modalTitle} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id={modalMessage} />
        {textCheck && (
          <input
            className={"mt-5 form-control form-control-lg form-control-solid"}
            onChange={(e) => setValidation(e.target.value)}
          />
        )}

        {warningMessage && (
          <div className="alert alert-custom alert-light-danger fade show mt-4 py-4" role="alert">
            <div className="alert-icon">
              <IconLoader icon="mdiAlertOutline" size={1} style={{ color: "#F64E60" }} />
            </div>
            <div className="alert-text">{warningMessage}</div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            id="dialog-cancel"
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate mr-2"
            disabled={isLoading}
          >
            <FormattedMessage id="DIALOG.CANCEL" />
          </button>
          <button
            id="dialog-confirmdelete"
            type="button"
            onClick={confirmDialog}
            className="btn btn-light-danger btn-elevate"
            disabled={textCheck ? textCheck?.trim() !== validation : isLoading}
          >
            <FormattedMessage id={deleteButtonLabel} />
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteDialog;
